import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { routes } from '../routes';

type PageTitleOptions = {
  /** Replaces the whole title (Users case) */
  replaceBaseTitle?: boolean;
  /** Replaces the URL ID with dynamicValue */
  replaceId?: boolean;
};

export const usePageTitle = (dynamicValue?: string, options?: PageTitleOptions) => {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;

    // Find matching route
    const matchedRoute = routes.find((route) => {
      const routePath = route.path || '';
      const pathSegments = pathname.split('/').filter(Boolean);
      const routeSegments = routePath.split('/').filter(Boolean);

      if (pathSegments.length === 0) {
        return routePath === 'dashboard' || !routePath;
      }

      return pathSegments[0] === routeSegments[0];
    });

    const defaultTitle = 'Unilode - Stroopwafl';
    const pageLabel = matchedRoute?.label;

    // Extract ID from URL if present (e.g., /readers/123 -> 123)
    const pathSegments = pathname.split('/').filter(Boolean);
    const idFromUrl = pathSegments.length > 1 ? pathSegments[1] : null;

    let newTitle: string;

    // Users
    if (options?.replaceBaseTitle && dynamicValue) {
      newTitle = `${dynamicValue} | Stroopwafl`;
    }
    // DETAIL PAGE WITH ID REPLACEMENT (Equipment)
    else if (pageLabel && idFromUrl && options?.replaceId && dynamicValue) {
      newTitle = `${pageLabel} | ${dynamicValue} | Stroopwafl`;
    }
    // NORMAL DETAIL PAGE
    else if (pageLabel && idFromUrl) {
      newTitle = `${pageLabel} | ${idFromUrl} | Stroopwafl`;
    }
    // LIST PAGE
    else if (pageLabel) {
      newTitle = `${pageLabel} | Stroopwafl`;
    } else {
      newTitle = defaultTitle;
    }

    document.title = newTitle;
  }, [location.pathname, dynamicValue, options?.replaceBaseTitle, options?.replaceId]);
};
